<div class="action-empty-state">
    <ng-content></ng-content>
    
    <div class="description">
        <span>{{'TRAVELCARD_EMPTY_STATE_DESCRIPTION' | translate}}</span>
    </div>
    <button class="btn btn--primary" [routerLink]="'add' | localize">
        <span>{{'TRAVELCARD_EMPTY_STATE_ADD_TRAVELCARD' | translate}}</span>
    </button>
</div>
